module.exports = __webpack_public_path__ + "src/assets/images/illustration_safeguards_laptop.svg?825d783b9d312871e197c2af0b57a7de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustration_safeguards_laptop.svg
// module id = 1011
// module chunks = 1